import { render } from "./BigPlayer.vue?vue&type=template&id=49a57e43"
import script from "./BigPlayer.vue?vue&type=script&lang=js"
export * from "./BigPlayer.vue?vue&type=script&lang=js"

import "./BigPlayer.vue?vue&type=style&index=0&id=49a57e43&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__